import React from 'react';

import { Typography } from '@mui/material';

import InsideLayout from '../layouts/Inside';

const Forbidden = () => {
  return (
    <InsideLayout>
      <Typography variant="h4">Access Denied.</Typography>
    </InsideLayout>
  );
};

export default Forbidden;
